(function () {
  'use strict';

  var INSURANCE_VARIANT_ID = 47650024521879;
  var INSURANCE_RATE = 0.14; // 14 % du prix de location (taux client, maj 2026-06 — était 0.25)
  var izyrentPrice = 0;
  var izyrentQty = 1;
  var cleanupRunning = false;

  function formatPrice(amount) {
    return '$' + amount.toFixed(2);
  }

  function isAssuranceChecked() {
    var cb = document.querySelector('.izyrent-assurance__checkbox');
    return cb && cb.checked;
  }

  // Fermeture du tiroir panier — delegation sur document (survit au remplacement
  // d'innerHTML par cart:refresh, qui fait perdre le listener natif du bouton croix).
  //
  // ⚠️ Le handler natif `onButtonClick` (theme.js) est un TOGGLE : `if (open) hide() else show()`.
  // Si on appelle hide() en capture PUIS que le natif tourne, il voit `!open` et ré-ouvre
  // → la croix « ne marche pas » (bug intermittent selon que le natif est ré-attaché).
  // Fix : on cible UNIQUEMENT la croix principale du tiroir (`[aria-controls="CartDrawer"]`
  // à l'intérieur de <cart-drawer>) et on coupe la propagation pour que le natif ne ré-ouvre pas.
  // Les croix de sous-panneaux (autres aria-controls) et le bouton d'ouverture (hors cart-drawer)
  // ne sont pas touchés.
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.drawer__close-btn[aria-controls="CartDrawer"]');
    if (!closeBtn) return;
    var drawer = closeBtn.closest('cart-drawer');
    if (!drawer || typeof drawer.hide !== 'function') return;
    e.preventDefault();
    e.stopImmediatePropagation(); // empêche le toggle natif de ré-ouvrir
    drawer.hide();
  }, true);

  // Listen for IzyRent price and quantity updates
  document.addEventListener('izyrentCheckDate', function (e) {
    if (e.detail) {
      if (typeof e.detail.price === 'number') {
        izyrentPrice = e.detail.price / 100;
        updateDisplayedPrice();
      }
      if (typeof e.detail.multiQty === 'number') {
        izyrentQty = e.detail.multiQty;
      }
    }
  });

  // Listen for IzyRent "after add to cart" event
  document.addEventListener('izyrentAfterAddToCart', function () {
    if (!isAssuranceChecked() || izyrentPrice <= 0) return;

    var perUnitInsurance = (izyrentPrice * INSURANCE_RATE).toFixed(2);

    setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var coveredVariants = {};
          cart.items.forEach(function (item) {
            if (item.variant_id === INSURANCE_VARIANT_ID && item.properties && item.properties._assurance_for) {
              coveredVariants[item.properties._assurance_for] = true;
            }
          });

          var rentalLine = null;
          for (var i = cart.items.length - 1; i >= 0; i--) {
            var item = cart.items[i];
            if (item.variant_id !== INSURANCE_VARIANT_ID && item.properties && item.properties.__izyrentValidation) {
              if (!coveredVariants[String(item.variant_id)]) {
                rentalLine = item;
                break;
              }
            }
          }

          if (!rentalLine) return;

          var productName = rentalLine.product_title || rentalLine.title;
          var totalInsurance = (parseFloat(perUnitInsurance) * rentalLine.quantity).toFixed(2);

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: INSURANCE_VARIANT_ID,
                quantity: rentalLine.quantity,
                properties: {
                  'Détails': productName + (rentalLine.quantity > 1 ? ' (x' + rentalLine.quantity + ')' : '') + ' — $' + totalInsurance,
                  _assurance_price: perUnitInsurance,
                  _assurance_for: String(rentalLine.variant_id),
                  _assurance_title: productName
                }
              }]
            })
          });
        })
        .then(function () {
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            // Update cart count bubble in header
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              document.querySelectorAll('cart-count, .cart-count-bubble span, .cart-count, [data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
                if (el.tagName === 'CART-COUNT') {
                  el.setAttribute('aria-label', cart.item_count + '\u00a0articles');
                }
              });
            });
          }, 300);
        })
        .catch(function (e) {
          console.error('Assurance add failed:', e);
        });
    }, 300);
  });

  // Update displayed insurance price on product page (per unit)
  function updateDisplayedPrice() {
    document.querySelectorAll('.izyrent-assurance__price').forEach(function (el) {
      if (izyrentPrice > 0) {
        el.textContent = formatPrice(izyrentPrice * INSURANCE_RATE);
      }
    });
  }

  // UI: show/hide checkbox based on IzyRent selectedDates
  function init() {
    var containers = document.querySelectorAll('.izyrent-assurance');
    if (!containers.length) return;

    var MAX_WAIT = 15000;
    var POLL_INTERVAL = 300;
    var elapsed = 0;

    function waitForIzyrent() {
      var izyrentEl = document.getElementById('izyrent');
      if (izyrentEl) {
        containers.forEach(function (container) {
          setupUI(container, izyrentEl);
        });
      } else if (elapsed < MAX_WAIT) {
        elapsed += POLL_INTERVAL;
        setTimeout(waitForIzyrent, POLL_INTERVAL);
      }
    }

    waitForIzyrent();
  }

  function setupUI(container, izyrentEl) {
    function checkVisibility() {
      var hasSelectedDates = izyrentEl.classList.contains('selectedDates');
      if (hasSelectedDates) {
        container.style.display = '';
        updateDisplayedPrice();
      } else {
        container.style.display = 'none';
      }
    }

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          checkVisibility();
        }
      });
    }).observe(izyrentEl, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('izyrentChange', function () { setTimeout(checkVisibility, 100); });
    document.addEventListener('izyrentClose', function () { setTimeout(checkVisibility, 100); });

    checkVisibility();
  }

  // Clean up orphaned assurance lines
  function cleanupOrphanedAssurance() {
    if (cleanupRunning) return;
    cleanupRunning = true;

    setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var rentalVariantIds = {};
          cart.items.forEach(function (item) {
            if (item.properties && item.properties.__izyrentValidation) {
              rentalVariantIds[String(item.variant_id)] = true;
            }
          });

          var keysToRemove = {};
          cart.items.forEach(function (item) {
            if (item.variant_id === INSURANCE_VARIANT_ID && item.properties && item.properties._assurance_for) {
              if (!rentalVariantIds[item.properties._assurance_for]) {
                keysToRemove[item.key] = 0;
              }
            }
          });

          if (Object.keys(keysToRemove).length > 0) {
            return fetch('/cart/update.js?_assurance_cleanup', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: keysToRemove })
            }).then(function () {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: {} }));
            });
          }
        })
        .catch(function () {})
        .then(function () {
          cleanupRunning = false;
        });
    }, 1500);
  }

  // Intercept fetch for cart changes
  var _origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var result = _origFetch.apply(this, arguments);

    if (typeof url === 'string' &&
        (url.includes('/cart/change') || url.includes('/cart/update')) &&
        !url.includes('izyrent') &&
        !url.includes('_assurance_cleanup')) {
      result.then(function () {
        cleanupOrphanedAssurance();
      });
    }

    return result;
  };

  // Also intercept XMLHttpRequest for cart changes (drawer may use XHR)
  var _origXHROpen = XMLHttpRequest.prototype.open;
  var _origXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function () {
    this._assuranceUrl = arguments[1];
    return _origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    var url = xhr._assuranceUrl || '';

    if ((url.includes('/cart/change') || url.includes('/cart/update')) &&
        !url.includes('izyrent') &&
        !url.includes('_assurance_cleanup')) {
      xhr.addEventListener('load', function () {
        cleanupOrphanedAssurance();
      });
    }

    return _origXHRSend.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
